import { render } from "./NestedMethod.vue?vue&type=template&id=b904267c&lang=pug"
import script from "./NestedMethod.vue?vue&type=script&lang=js"
export * from "./NestedMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__